var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCbseNep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CBSE &amp; NEP 2020 Aligned") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "dot",
    r: 2.2,
    fill: "#1E3A8A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,120)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -86,
    r: 2.2,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 86,
    r: 2.2,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 0,
    r: 2.2,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -86,
    cy: 0,
    r: 2.2,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(12)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(24)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(36)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(48)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(84)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(96)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(108)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(132)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(156)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(168)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(192)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(204)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(216)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(228)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(252)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(264)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(288)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(312)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(324)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(336)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(348)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -86
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -68,
    r: 1.8,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 68,
    r: 1.8,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 0,
    r: 1.8,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -68,
    cy: 0,
    r: 1.8,
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(15)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(30)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(60)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(75)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(105)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(150)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(165)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(195)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(210)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(255)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(285)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(330)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(345)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#dot",
    x: 0,
    y: -68
  })))), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 112,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 16,
    fill: "#1E3A8A",
    fontWeight: 600
  }, "\n      CBSE &amp;\n    "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 134,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 16,
    fill: "#1E3A8A",
    fontWeight: 600
  }, "\n      NEP 2020\n    "), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 156,
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, sans-serif",
    fontSize: 16,
    fill: "#1E3A8A",
    fontWeight: 600
  }, "\n      Aligned\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbseNep);
export default __webpack_public_path__ + "static/media/cbse-nep.d5841011b5716050d6e0747eac73cfd6.svg";
export { ForwardRef as ReactComponent };